import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white text-[#5C564E] pt-16 pb-12 border-t border-[#E8E2D9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 pb-12 border-b border-[#EFEBE4]">
          {/* Brand Col */}
          <div className="lg:col-span-2 space-y-4">
            <Link to="/" className="flex items-center gap-3 sm:gap-3.5 text-[#161514] font-bold tracking-tight group">
              <div className="flex flex-col justify-center select-none text-left">
                <span className="font-black text-xl sm:text-2xl text-[#161514] tracking-tight leading-none">
                  My Service
                </span>
                <span className="text-[11px] sm:text-xs font-bold text-[#A8885B] tracking-[0.22em] uppercase leading-none mt-1">
                  For You
                </span>
              </div>
            </Link>
            <p className="text-sm text-[#706B63] max-w-sm leading-relaxed">
              Skræddersyet sparring, videoredigering og content til hospitality- og servicebranchen.
            </p>
          </div>

          {/* Navigation Col 1 */}
          <div className="space-y-3">
            <h4 className="text-xs uppercase tracking-widest text-[#8C867D] font-bold">
              Ydelser & Områder
            </h4>
            <ul className="space-y-2 text-sm text-[#5C564E]">
              <li>
                <Link to="/ydelser/content-redigering" className="hover:text-[#161514] transition-colors">
                  Content Opsætning & Redigering
                </Link>
              </li>
              <li>
                <Link to="/ydelser/online-vejledning" className="hover:text-[#161514] transition-colors">
                  Online Vejledning (Foto & Video)
                </Link>
              </li>
              <li>
                <Link to="/ydelser/meta-postkalender" className="hover:text-[#161514] transition-colors">
                  Meta SoMe Postkalender
                </Link>
              </li>
              <li>
                <Link to="/ydelser/profil-opsaetning" className="hover:text-[#161514] transition-colors">
                  Opsætning af Sociale Medier
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation Col 2 */}
          <div className="space-y-3">
            <h4 className="text-xs uppercase tracking-widest text-[#8C867D] font-bold">
              Virksomhed
            </h4>
            <ul className="space-y-2 text-sm text-[#5C564E]">
              <li>
                <Link to="/om-os" className="hover:text-[#161514] transition-colors">
                  Om Myserviceforyou
                </Link>
              </li>
              <li>
                <Link to="/saadan-arbejder-vi" className="hover:text-[#161514] transition-colors">
                  Sådan arbejder vi
                </Link>
              </li>
              <li>
                <Link to="/cases" className="hover:text-[#161514] transition-colors">
                  Cases & Referencer
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#161514] transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="space-y-3">
            <h4 className="text-xs uppercase tracking-widest text-[#8C867D] font-bold">
              Kontakt & Dialog
            </h4>
            <div className="space-y-2 text-sm text-[#5C564E]">
              <p>
                <span className="text-[#8C867D] block text-xs">Telefon</span>
                <a href="tel:+4561489206" className="hover:text-[#A8885B] transition-colors no-break font-medium text-[#161514]">
                  +45 61 48 92 06
                </a>
              </p>
              <p>
                <span className="text-[#8C867D] block text-xs">Email</span>
                <a href="mailto:info.myserviceforyou@gmail.com" className="hover:text-[#A8885B] transition-colors no-break font-medium text-[#161514]">
                  info.myserviceforyou@gmail.com
                </a>
              </p>
              <p className="text-xs text-[#8C867D] pt-1">
                Sparring · Redigering · Synlighed
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#8C867D]">
          <p>© {new Date().getFullYear()} Myserviceforyou. Alle rettigheder forbeholdes. · CVR: 46 69 75 53</p>
          <div className="flex items-center gap-6">
            <Link to="/kontakt" className="hover:text-[#161514] transition-colors">
              Uforpligtende kontakt
            </Link>
            <Link to="/kontakt" className="hover:text-[#161514] transition-colors">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
